// Version : 1.0.0
// Author : AGALYA

import { takeLatest, put, call, all } from 'redux-saga/effects';
import AdvanceMemberActionType from './advance-member.types';
import {
	fetchAdvanceMemberListSuccess,
	fetchAdvanceMemberListFailure,
	fetchAdvanceMemberListResponseChanged,
} from './advance-member.action';
import { fetchAdvanceMemberListService } from './advance-member.service';

import { encryptData } from '../../../_common/enode-decode';

/** ***************** FETCH ADVANCE MEMBER LIST START *********************** */
export function* fetchAdvanceMemberList({ payload }: any): any {
	try {
		const {
			companyID,
			userID,
			databaseName,
			userAccessBranchID,
			Status,
			limit,
			InputSearch,
			MemberName,
			CreatedFrom,
			CreatedTo,
			FromAge,
			ToAge,
			EconomicActivityID,
			CenterID,
			GroupID,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			DatabaseName: databaseName,
			BranchID: userAccessBranchID,
			MemberStatus: Status,
			limit,
			InputSearch,
			MemberName,
			CreatedFrom,
			CreatedTo,
			FromAge,
			ToAge,
			EconomicActivityID,
			CenterID,
			GroupID,
		};
		const key = 'MemberDetailsKey';
		const encodeData = encryptData(jsonData, key);
		const response = yield call(fetchAdvanceMemberListService, encodeData);
		if (response.statusCode == '01') {
			yield put(fetchAdvanceMemberListSuccess(response));
		} else {
			yield put(fetchAdvanceMemberListFailure(response.response));
		}
	} catch (error) {
		yield put(fetchAdvanceMemberListFailure(error));
	}
}

export function* onAdvanceMemberListFetch() {
	yield takeLatest(
		AdvanceMemberActionType.FETCH_ADVANCE_MEMBER_LIST_START,
		fetchAdvanceMemberList,
	);
}

export function* resetAdvanceMemberList() {
	yield put(fetchAdvanceMemberListResponseChanged());
}

export function* onResetAdvanceMemberList() {
	yield takeLatest(
		AdvanceMemberActionType.FETCH_ADVANCE_MEMBER_LIST_RESPONSE_REST_START,
		resetAdvanceMemberList,
	);
}
/** ***************** FETCH ADVANCE MEMBER LIST END *********************** */

export function* advanceMemberSaga() {
	yield all([call(onAdvanceMemberListFetch), call(onResetAdvanceMemberList)]);
}
